<template>
  <div>
    <!-- add leave Modal -->
    <div
      class="modal fade claender-modal"
      id="calenModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Add Leave</h5>
              <p class="gray-text">
                Pick employee below that you want to create leave for...
              </p>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearleave2"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-wrapper">
              <p>
                You are about to create leave. Please choose a period and the
                type of
                <br/>
                leave. On the next page, you will see the consequences of the
                leave.
              </p>
            </div>
            <div class="add-type">
              <ul class="type-list">
                <li>
                  <label class="custom-radio">
                    <input type="radio" name="leaveTypeRadio" v-model="leaveTypeWhenUpdate" v-bind:value="'Vacation'">
                    <span class="radio-check">Vacation</span>
                  </label>
                </li>
                <li>
                  <label class="custom-radio">
                    <input type="radio" name="leaveTypeRadio" v-model="selectedLeave" v-bind:value="'Sick'"/>
                    <span class="radio-check">Sick</span>
                  </label>
                </li>

              </ul>
              <ul class="type-list" v-show="addedRadioButton">
                <li>
                  <label class="custom-radio">
                    <input type="radio" class="" name="leaveTypeRadio leeave-type" v-model="selectedLeave"
                           :value="leaveType2"/>
                    <span class="radio-check">{{ leaveType2 }}</span>
                  </label>
                </li>
              </ul>
              <ul class="type-list">

               <li>
                 <label for="">Leave Types*</label>
                 <select name="" class="form-control text-capitalize" v-model="company_leave_type_id" @change="getEmployeeLeaveBalance($event)"  >
                   <option value="" v-if="companyLeaveTypes" v-for="leaveType in SpecificEmployeeLeaveTypes" :value="leaveType.id" class="text-capitalize">
                     {{ leaveType.name }}
                   </option>
                 </select>
                 <br>
                 <a v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))"  href="javascript:void(0)" class="col-blue" @click="addInputFiled">Add New</a>
               </li>
              </ul>
<!--              <div class="alwd-leave">Leave Balance: {{ leavesAllowed >= 0 ? leavesAllowed : leavesAllowed < 0 ? 0 : totalAllowedLeaves }}</div>-->
              <div class="alwd-leave">Leave Balance: <span v-if="employeeLeaveBalance">{{ employeeLeaveBalance.leave_balance }}</span> <span v-else>--</span></div>
              <ul class="type-list">
                <li v-if="inputShowHide">
                  <div class="input-group mt-10">
                    <input type="text" class="form-control" placeholder="Add leave type" v-model="leaveType">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button" @click="submitCompanyLeaveType">Save</button>
                    </div>
                  </div>
                  <p v-if="invalidType === 'invalid'" :class="{textRed: invalidType === 'invalid'}">Leave type is
                    required</p>
                </li>
              </ul>
            </div>
            <ul class="period-list">
              <li @click="getDateRanges2($event,'today')" class="selected first-li">
                <span class="period-btn">Today</span>
              </li>
              <li @click="getDateRanges2($event,'tomorrow')">
                <span class="period-btn">Tomorrow <span class="sub-date">{{ nextDay }}</span></span>
              </li>
              <li @click="getDateRanges2($event,'other')">
                <div class="period-btn">
                  <span class="label">Choose specific period</span>
                  <div class="date-con">
                    <date-picker v-model="range" lang="en" @change="dateUpdateLeave($event)" range type="date"
                                 format="DD-MM-YYYY" width="300"
                                 :input-attr="{autocomplete:'new-password',onfocus:'this.removeAttribute(readonly);',readonly:'readonly'}"
                    >
                      <template v-slot:footer="{ emit }">
                        <span style="text-align: left;float: left;">
                          <button class="btn mx-btn mx-btn-text" @click="getDateRanges(emit,'today')">Today</button>
                          <button class="btn mx-btn mx-btn-text"
                                  @click="getDateRanges(emit,'tomorrow')">Tomorrow</button>
                          <button class="btn mx-btn mx-btn-text" @click="getDateRanges(emit,'twodays')">TwoDays</button>
                          <button class="btn mx-btn mx-btn-text"
                                  @click="getDateRanges(emit,'threedays')">ThreeDays</button>
                        </span>
                      </template>
                    </date-picker>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="period-list periodList ">
              <li class="">
                <div>
                <label for="" class="d-block">Duration</label>
                <select class="leave_duration_dropdown valid" v-model="duration_type" @change="onChangeType($event)"
                        >
                  <option value="full_day" selected>Full Day</option>
                  <option value="half_day">Half Day</option>
                  <option value="specify_time">Specify Time</option>
                </select>
                </div>
              </li>
              <li class="" v-if="isHalfDayType">
                <div>
                  <select name=""  v-model="is_half_day_type">
                    <option value="morning">Morning</option>
                    <option value="evening">Evening</option>
                  </select>
                </div>
              </li>
              <!-- Quarters Selection -->
              <li v-if="isSpecifyTimeType">
                <div>
                  <label for="" class="d-block">Select Duration</label>
                  <select class="timepicker valid" v-model="time_type">
                    <option value="">Select</option>
                    <option v-for="option in timeOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </li>
<!--              <li class="" v-if="isSpecifyTimeType">
                <div>
                  <label for="" class="d-block">To</label>
                  <select id="applyleave_duration_time_to" class="timepicker valid" v-model="to_specify_time">
                    <option value="">Select</option>
                    <option :value="timeSlot" v-for="timeSlot in specificTimes">{{ timeSlot }}</option>
                  </select>
                </div>
              </li>-->
            </ul>

            <div class="form-group">
              <label for="">Note about leave</label>
              <textarea class="form-control" v-model="leaveNote"></textarea>
            </div>
            <div class="form-group">
              <label for="">Attachment</label>
              <input class="form-control" type="file" @change="leaveAttachment($event)">
            </div>
            <p v-if="rangeRequired === 'invalid'" :class="{textRed: rangeRequired === 'invalid'}" class="pcls">Date is
              required</p>
            <p v-if="leaveNotAvailable === 'invalid'" :class="{textRed: leaveNotAvailable === 'invalid'}" class="pcls"
               v-text="leaveStatusText">Employee already on leave on this day</p>
          </div>

          <div class="modal-footer ">
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              id="consequence-leave"
              @click="checkLeaveStatus($event)"
            >
              See consequences of leave
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- confirm leave modal -->
    <div
      class="modal fade "
      id="absenceModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="absenceModelLabel"
      aria-hidden="true"
    >

      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content absence-model ">
          <div class="modal-header">
            <h5 class="modal-title" id="absenceModelLabel">
              Confirm your leave
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearleave2"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Your leave is
              <strong>  {{ leaves.startTime | moment('ddd MMM DD YYYY') }} to {{ leaves.endTime | moment('ddd MMM DD YYYY') }}</strong>
              with leave type
              <strong> {{ leaves.type }}</strong>
            </p>
            <p class="bg-gray" v-if="employeeShifts.length == 0">
              <span class="text-capitalize">{{ leaves.name }}</span> has no prior or upcoming shifts in the period.
            </p>
            <div class="bg-gray" v-else>
              <p v-for="(shift,index) of employeeShifts" :key="index">
                <span class="text-capitalize">{{ leaves.name }}</span> has shift on following date {{ shift.date }} from
                {{ shift.start_time }} to {{ shift.end_time }}
              </p>
            </div>
            <p>
              The leave is visible on <span class="text-capitalize">{{ leaves.name }}</span> profile page, Hours &
              Salary and
              in the Excel export.
            </p>

          </div>

          <div class="modal-footer">

            <a
              href="javascript:void(0)"
              class="btn btn-outline-warning btn-sm"
              data-dismiss="modal"
              aria-label="Close"
              @click="leave2BackBtn"
            >
              Back
            </a>

            <button type="button" @click="saveLeave" class="btn btn-outline-primary btn-sm" data-dismiss="modal"
                    aria-label="Close">
              Create leave
            </button>

          </div>

        </div>

      </div>

    </div>

    <!-- update leave modal -->
    <div
      class="modal fade claender-modal"
      id="itemShowModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5 class="text-capitalize">{{ editLeave.name }}</h5>
              <p class="gray-text">
                Pick employee below that you want to edit leave for..
              </p>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="clearleave"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-wrapper">
              <p>
                Your are about to edit leave. Please choose a period and the
                type of
                <br/>
                leave. On the next page, you will see the consequences of the
                leave.
              </p>
            </div>
            <div class="add-type">
              <ul class="type-list">
                <li>
                  <label class="custom-radio">
                    <input type="radio" name="leaveTypeRadio" :checked="editLeave.type=='Vacation'" value="Vacation"/>
                    <span class="radio-check">Vacation</span>
                  </label>
                </li>
                <li>
                  <label class="custom-radio">
                    <input type="radio" name="leaveTypeRadio" :checked="editLeave.type=='Sick'" value="Sick"/>
                    <span class="radio-check">Sick</span>
                  </label>
                </li>
              </ul>
              <ul class="type-list" v-show="leaveTypeWhenUpdate!=='Sick' && leaveTypeWhenUpdate!=='Vacation'">
                <li>
                  <label class="custom-radio">
                    <input type="radio" class="" name="leaveTypeRadio"
                           :checked="leaveTypeWhenUpdate!=='Sick' && leaveTypeWhenUpdate!=='Vacation'"
                           :value="leaveTypeWhenUpdate"/>
                    <span class="radio-check">{{ leaveTypeWhenUpdate }}</span>
                  </label>
                </li>
              </ul>
              <ul class="type-list">
                <li>
                  <label for="">Leave Types*</label>
                  <select name="" class="form-control text-capitalize" v-model="editLeave.company_leave_type_id" @change="getEmployeeLeaveBalance($event)"  >
                    <option value="" v-if="companyLeaveTypes" v-for="leaveType in companyLeaveTypes" :value="leaveType.id"  class="text-capitalize">
                      {{ leaveType.name }}
                    </option>
                  </select>
                  <br>
                  <a href="javascript:void(0)" class="col-blue" @click="addInputFiled">Add Type</a>
                </li>
              </ul>
              <div class="alwd-leave">Leave Balance: <span v-if="employeeLeaveBalance">{{ employeeLeaveBalance.leave_balance }}</span> <span v-else>--</span></div>
              <ul class="type-list">
                <li v-show="inputShowHide">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="add leave type" v-model="leaveType"
                          >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" @click="submitCompanyLeaveType" type="button">Save</button>
                    </div>
                  </div>
                  <p v-if="invalidType === 'invalid'" :class="{textRed: invalidType === 'invalid'}">Leave type is
                    required</p>
                </li>
              </ul>
            </div>
            <ul class="period-list">
              <li @click="getDateRanges2($event,'today')">
                <span class="period-btn">Today</span>
              </li>
              <li @click="getDateRanges2($event,'tomorrow')">
                <span class="period-btn">Tomorrow <span class="sub-date">{{ nextDay }}</span></span>
              </li>
              <li class="selected" @click="getDateRanges2($event,'other')">
                <div class="period-btn">
                  <span class="label">Choose specific period</span>
                  <div class="date-con">
                    <date-picker v-model="rangeUpdate" lang="en" @change="dateUpdateLeave($event)" range type="date"
                                 format="DD-MM-YYYY" width="300"
                                 :input-attr="{autocomplete:'new-password',onfocus:'this.removeAttribute(readonly);',readonly:'readonly'}"
                    >
                      <template v-slot:footer="{ emit }">
                        <span style="text-align: left;float: left;">
                          <button class="btn mx-btn mx-btn-text" @click="getDateRanges(emit,'today')">Today</button>
                          <button class="btn mx-btn mx-btn-text"
                                  @click="getDateRanges(emit,'tomorrow')">Tomorrow</button>
                          <button class="btn mx-btn mx-btn-text" @click="getDateRanges(emit,'twodays')">TwoDays</button>
                          <button class="btn mx-btn mx-btn-text"
                                  @click="getDateRanges(emit,'threedays')">ThreeDays</button>
                        </span>
                      </template>
                    </date-picker>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="period-list periodList ">
              <li class="">
                <div>

                  <label for="" class="d-block">Duration</label>
                  <select class="leave_duration_dropdown valid" v-model="editLeave.duration_type" @change="onChangeType($event)"
                          id="applyleave_duration_duration">
                    <option :value="'full_day'">Full Day</option>
                    <option :value="'half_day'">Half Day</option>
                    <option :value="'specify_time'">Specify Time</option>
                  </select>
                </div>
              </li>
              <li class="" v-if="isHalfDayType">
                <div>
                  <select name="" id="" v-model="editLeave.is_half_day_type">
                    <option value="morning">Morning</option>
                    <option value="evening">Evening</option>
                  </select>
                </div>
              </li>
              <li class="" v-if="isSpecifyTimeType">
                <div>
                  <label for="" class="d-block">From</label>
                  <select  class="timepicker  valid" v-model="editLeave.time_type">
                    <option value="">Select</option>
<!--                    <option :value="timeSlot" v-for="timeSlot in specificTimes">{{ timeSlot }}</option>-->
                    <option v-for="option in timeOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </li>
<!--              <li class="" v-if="isSpecifyTimeType">
                <div>
                  <label for="" class="d-block">To</label>
                  <select class="timepicker valid" v-model="editLeave.to_specify_time">
                    <option value="">Select</option>
                    <option :value="timeSlot" v-for="timeSlot in specificTimes">{{ timeSlot }}</option>
                  </select>
                </div>
              </li>-->
            </ul>




            <div class="form-group">
              <label for="">Note about absence (visible to Admin and <span class="text-capitalize">{{ editLeave.name }}</span>)</label>
              <textarea class="form-control" v-model="editLeave.note"></textarea>
            </div>
            <p v-if="rangeRequired === 'invalid'" :class="{textRed: rangeRequired === 'invalid'}">Date is required</p>
            <p v-if="leaveNotAvailable === 'invalid'" :class="{textRed: leaveNotAvailable === 'invalid'}" class="pcls"
               v-text="leaveStatusText">Employee already on leave on this day</p>
          </div>

          <div class="modal-footer ">
            <button type="button" class="btn btn-outline-primary btn-sm" @click="deleteLeave">Delete</button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              id="edit-leave"
              @click="updateEmployeeLeave"
            >
              Update
            </button>

          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment'
import axios from "axios";
export default {
  components: {
    DatePicker
  },
  props: [
    "shiftData",
    "editLeave",
    "leaveData",
    "leaveTypeWhenUpdate",
    "leavesAllowed",
    "rangeUpdate",
    "totalAllowedLeaves",
    "company_leave_type_id",
    "employeeLeaveBalance",
    "getEmployeeLeaveEntitlements"
  ],
  data() {
    return {
      employeeId: this.$store.getters.getEmployeeProfileId,
      // specificTimes: ['10:00','12:30','14:30','16:30','19:00'],
      timeOptions: [
        { label: "1st Quarter", value: "1" },
        { label: "2nd Quarter", value: "2" },
        { label: "3rd Quarter", value: "3" },
        { label: "4th Quarter", value: "4" },
      ],
      // specificTimes: [],
      searchByRole: [],
      searchByLeaveType: [],
      searchByEmployee: [],
      jobRoles: this.$store.getters.getSelectedCompany.jobRoles,
      user: this.$store.getters.getUser,
      showDate: new Date(),
      item: [],
      copyItems: [],
      filteredEmployees: [],
      employees: [],
      inputShowHide: false,
      leaveType: '',
      leaveType2: '',

      addedRadioButton: false,

      selectedLeave: 'Vacation',
      leaveDate: '',
      date: '',
      time: '',
      datetime: '',
      range: '',
      range2: '',
      leaveNote: '',
      duration_type: 'full_day',
      is_half_day_type: '',
      time_type: '',
      from_specify_time: '',
      to_specify_time: '',
      time_range_duration: '',
      search: '',
      // leaveData               :[],
      leaves: [],
      // shiftData               :[],
      employeeShifts: [],
      getEmployeeLeaves: [],
      leavesNames: [],
      searchEmployeeForLeave: [],
      // editLeave               :{},
      rangeRequired: '',
      pendingLeaveEmployee: [],
      pendingLeaveCount: 0,
      acceptClass: '',
      rejectClass: '',
      invalidType: '',
      leaveNotAvailable: '',
      leaveStatusText: '',
      imgNotFnd: false,
      attachmentFile: '',
      nextDay: '',

      isHalfDayType: false,
      isSpecifyTimeType: false,
      companyLeaveTypes:[],
      SpecificEmployeeLeaveTypes:[],
      company_id: this.$store.getters.getSelectedCompany.id,
    }
  },
  watch:{
    editLeave(newVal,oldVal){
      if(newVal.duration_type == "full_day"){
        this.isSpecifyTimeType = false;
        this.isHalfDayType = false;
      }else if(newVal.duration_type == "half_day"){
        this.isSpecifyTimeType = false;
        this.isHalfDayType = true;
      }else if(newVal.duration_type == "specify_time"){
        this.isSpecifyTimeType = true;
        this.isHalfDayType = false;
      }
    },
    duration_type(newVal) {
      if (newVal === "half_day") {
        this.isHalfDayType = true;
        this.isSpecifyTimeType = false;
      } else if (newVal === "specify_time") {
        this.isSpecifyTimeType = true;
        this.isHalfDayType = false;
      } else {
        this.isHalfDayType = false;
        this.isSpecifyTimeType = false;
      }
    }

  },
  created() {
    this.$root.$on("leaveTypeUpdate", (emplId) => {
      this.getSpecificEmployeeLeaveTypes(emplId);
    });
    this.selectedLeave = 'Vacation';
    this.getCompanyLeaveTypes();
    this.getSpecificEmployeeLeaveTypes(this.employeeId.id);
    // this.getCompanySpecificTimes();
  },
  methods: {
    getEmployeeLeaveBalance(event){
      axios.get(this.$EmployeeLeaveEntitlements+'/leave-balance', {
        headers: this.getAuthHeader(),
        params: {
          company_leave_type_id: event.target.value,
          employee_id: (this.leaveData['empl_Id'] !=undefined)?this.leaveData['empl_Id']:this.editLeave.emplId,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.employeeLeaveBalance = res.data.result;
          }
        });
    },
    getCompanyLeaveTypes() {
      axios.get(this.$CompanyLeaveTypes, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.companyLeaveTypes = res.data.result;
          }
        });
    },
    getSpecificEmployeeLeaveTypes(empl_id) {
      axios.get(this.$SpecificEmployeeLeaveTypes, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
          employee_id: empl_id
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.SpecificEmployeeLeaveTypes = res.data.result;
          }
        });
    },
    getCompanySpecificTimes() {
      axios.get(this.$CompanySpecificTimes, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.specificTimes = res.data.result;
          }
        });
    },
    onChangeType(event) {
      if (event.target.value === "half_day") {
        this.isHalfDayType = true;
        this.isSpecifyTimeType = false;
      } else if (event.target.value === "specify_time") {
        this.is_half_day_type= '';
        this.isHalfDayType = false;
        this.isSpecifyTimeType = true;
      } else {
        this.is_half_day_type= '';
        this.time_type= '';
        this.from_specify_time= '';
        this.to_specify_time= '';
        this.isHalfDayType = false;
        this.isSpecifyTimeType = false;
      }

    },
    leaveAttachment(event) {
      const file = event.target.files[0];
      this.attachmentFile = file;
    },
    getDateRanges(emit, type) {
      const start = new Date();
      const end = new Date();
      if (type === 'today') {
        const date = [start, end];
        emit(date);
      } else if (type === 'tomorrow') {
        start.setDate(start.getDate() + 1);
        end.setDate(end.getDate() + 1);
        const date = [start, end];
        emit(date);
      } else if (type === 'twodays') {
        end.setTime(end.getTime() + 1 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      } else if (type === 'threedays') {
        end.setTime(end.getTime() + 2 * 24 * 3600 * 1000);
        const date = [start, end];
        emit(date);
      }
    },
    saveLeave() {
      let dataArr                   = {};
      dataArr['company_leave_type_id']            = this.company_leave_type_id;
      dataArr['empl_id']            = this.leaves.empl_Id;
      dataArr['startDate']          = this.leaves.startTime;
      dataArr['endDate']            = this.leaves.endTime;
      dataArr['type']               = this.leaves.type;
      dataArr['company_id']         = this.$store.getters.getSelectedCompany.id;
      dataArr['note']               = this.leaveNote;
      dataArr['duration_type']      = this.duration_type;
      dataArr['is_half_day_type']   = this.is_half_day_type;
      dataArr['time_type']  = this.time_type;
      dataArr['from_specify_time']  = this.from_specify_time;
      dataArr['to_specify_time']    = this.to_specify_time;
      dataArr['file']               = this.attachmentFile;
      this.$axios({
        method: 'POST',
        data: dataArr,
        url: this.$SaveLeaveData,
        headers: this.getImageHeader()
      }).then((res) => {
        if (res.data.status == 200) {
          $('#absenceModel').modal('hide');
          $root.$toast.success(res.data.message);
          this.$root.$emit("refreshLeaves");
          this.inputShowHide = false;
          this.range = '';
          this.selectedLeave = 'Vacation';
          this.leaveType = '';
          this.getEmployeeLeaveEntitlements();
          if (this.employeeShifts.length>0) {
            this.getRidOfShiftsAfterLeaveSave(dataArr);
          }
          // this.$router.go(0);
        }
      });

    },
    getRidOfShiftsAfterLeaveSave(leaveData) {
      this.$axios({
        method: 'POST',
        data: {shifts: this.employeeShifts,leaveData:leaveData},
        url: this.$GetRidOfShiftsAfterLeave,
        headers: this.getAuthHeader()
      }).then((res) => {

      });
    },
    deleteLeave() {
      this.selectedLeave = '';
      if (confirm('Are you sure you want to delete this leave?')) {
        this.$axios({
          method: 'POST',
          data: {
            'company_id': this.$store.getters.getSelectedCompany.id,
            'employee_id': this.employeeId.id,
            'id': this.editLeave.id
          },
          url: this.$DeleteEmplLeave,
          headers: this.getAuthHeader()
        }).then((res) => {
          if (res.data.status == 200) {
            this.range = '';
            $('#itemShowModal').modal('hide');
            this.searchByRole = [];
            this.searchByLeaveType = [];
            this.searchByEmployee = [];
            this.addedRadioButton = false;
            this.selectedLeave = 'Vacation';
            this.leaveNote = '';
            this.$root.$emit("refreshLeaves");
            $root.$toast.success('Leave deleted seccessfully');
          }
        });
      }
    },
    checkLeaveStatus(event) {
      this.getingLeaveData(event);
      let dataArr           = {};

      dataArr['empl_id']    = this.leaves.empl_Id;
      dataArr['startDate']  = this.leaves.startTime;
      dataArr['endDate']    = this.leaves.endTime;
      dataArr['type']       = this.leaves.type;
      dataArr['company_id'] = this.$store.getters.getSelectedCompany.id;
      dataArr['note']       = this.leaveNote;
      dataArr['duration_type']       = this.duration_type;
      dataArr['is_half_day_type']       = this.is_half_day_type;
      dataArr['time_type']       = this.time_type;
      dataArr['from_specify_time']       = this.from_specify_time;
      dataArr['to_specify_time']       = this.to_specify_time;
      this.$axios({
        method: 'POST',
        data: dataArr,
        url: this.$CheckLeaveStatus,
        headers: this.getAuthHeader()
      }).then((res) => {
        if (res.data.result) {
          $('#calenModel').modal('hide');
          $('#absenceModel').modal('show');
          this.leaveNotAvailable = '';
        } else {
          this.leaveStatusText = res.data.message;
          this.leaveNotAvailable = 'invalid';
        }

      });

    },
    updateEmployeeLeave() {

      // if(this.range !== ''){
       this.range = this.rangeUpdate;
      this.rangeRequired = '';
      $('#edit-leave').removeAttr('disabled');
      var dataArr           = {};
      dataArr['company_leave_type_id']    = this.editLeave.company_leave_type_id;
      dataArr['empl_id']    = this.editLeave.emplId;
      dataArr['id']         = this.editLeave.id;
      dataArr['startDate']  = moment(this.range[0]).format('YYYY-MM-DD');
      dataArr['endDate']    = moment(this.range[1]).format('YYYY-MM-DD');
      dataArr['type']       = $('input[name="leaveTypeRadio"]:checked').val();
      dataArr['company_id'] = this.$store.getters.getSelectedCompany.id;
      dataArr['note']       = this.editLeave.note;
      dataArr['duration_type'] = this.editLeave.duration_type;
      dataArr['file'] = this.editLeave.file;
      if(this.editLeave.duration_type == "half_day"){
        dataArr['is_half_day_type'] = this.editLeave.is_half_day_type;
      }else if(this.editLeave.duration_type == "specify_time"){
        dataArr['time_type']  = this.editLeave.time_type;
        dataArr['from_specify_time']  = this.editLeave.from_specify_time;
        dataArr['to_specify_time']    = this.editLeave.to_specify_time;
      }
      this.$axios({
        method: 'POST',
        data: dataArr,
        url: this.$UpdateLeaveData,
        headers: this.getAuthHeader()
      }).then((res) => {
        if (res.data.result) {
          this.leaveNotAvailable  = '';
          this.leaveCheckUpdate   = true;
          this.editEmplLeave(dataArr);
             this.$router.go(0);
        } else {
          this.leaveNotAvailable  = 'invalid';
          this.leaveCheckUpdate   = false;
          this.leaveStatusText    = res.data.message;
        }
      });
    },
    editEmplLeave(datarr = {}) {
      this.$axios({
        method: 'POST',
        data: datarr,
        url: this.$SaveLeaveData,
        headers: this.getAuthHeader()
      }).then((res) => {
        if (res.data.status == 200) {
          this.range = '';
          this.rangeUpdate = '';
          $('#itemShowModal').modal('hide');
          this.selectedLeave = 'Vacation'
          this.addedRadioButton = false
          this.$root.$emit("refreshLeaves");
        }
      });
    },
    getingLeaveData(event) {
      if (this.range === '') {
        this.range = [new Date(), new Date];
      }
      if (this.range !== '') {
        this.leaves = [];
        // this.selectedLeave      = $('input[name="leaveTypeRadio"]:checked').val();
        this.leaveData['type'] = this.selectedLeave;

        let startdate = new Date(this.range[0]);
        let fulDateStart = startdate.toDateString();
        fulDateStart = fulDateStart + " " + startdate.getHours() + ":" + startdate.getMinutes() + ":" + startdate.getSeconds();
        this.leaveData['startTime'] = fulDateStart;

        let endDate = new Date(this.range[1]);
        let fulDateEnd = endDate.toDateString();
        fulDateEnd = fulDateEnd + " " + endDate.getHours() + ":" + endDate.getMinutes() + ":" + endDate.getSeconds();
        this.leaveData['endTime'] = fulDateEnd;

        this.leaves = this.leaveData;
        // this.selectedLeave  = 'Vacation';
        // this.range          = '';
        let fromdate = startdate.getFullYear() + '-' + (startdate.getMonth() + 1) + '-' + startdate.getDate();
        let toDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();

        this.employeeShifts = this.shiftData.filter(item => {
          let itemFromDat = new Date(item.date);
          itemFromDat = itemFromDat.getFullYear() + '-' + (itemFromDat.getMonth() + 1) + '-' + itemFromDat.getDate();
          if (itemFromDat >= fromdate && itemFromDat <= toDate) {
            return item;
          }
        });
        this.rangeRequired = ''
      } else {
        this.rangeRequired = 'invalid'
        return false;
      }
    },
    getDateRanges2(event, type) {
      const start = new Date();
      const end   = new Date();
      if (type === 'today') {
        this.rangeUpdate = this.range = [start, end];
      } else if (type === 'tomorrow') {
        start.setDate(start.getDate() + 1);
        end.setDate(end.getDate() + 1);
        this.rangeUpdate = this.range = [start, end];
        this.nextDay = start.toLocaleDateString('default', { weekday: 'long' })
      }
      $('.period-list li.selected').removeClass('selected');
      $(event.currentTarget).addClass('selected');
    },
    dateUpdateLeave(event) {
      this.leaveNotAvailable = '';
      if (event[0] == null) {
        this.rangeRequired = 'invalid';
        $('#edit-leave').attr('disabled', 'disabled');
        $('#consequence-leave').attr('disabled', 'disabled');
      } else {
        this.rangeRequired = '';
        $('#edit-leave').removeAttr('disabled');
        $('#consequence-leave').removeAttr('disabled');
      }
    },
    clearleave2() {
      this.addedRadioButton = false;
      this.inputShowHide = false
      this.selectedLeave = 'Vacation';
      this.leaveTypeWhenUpdate = 'Vacation';
      this.range = '';
      this.leaveNotAvailable = '';
      document.querySelector(".modal-backdrop").remove();
      this.$root.$emit("refreshCompo");
      $('.period-list li.selected').removeClass('selected');
      $('.first-li').addClass('selected');
    },
    leave2BackBtn(){
      $('#calenModel').modal('show');
      $('#absenceModel').modal('hide');
    },
    clearleave() {
      this.addedRadioButton = false;
      this.inputShowHide = false
      // this.selectedLeave = 'Vacation';
      // this.leaveTypeWhenUpdate = 'Vacation';
      this.range = '';
      this.leaveNotAvailable = '';
      // this.$root.$emit("refreshCompo");
    },
    addInputFiled() {
      if (this.inputShowHide == false) {
        this.inputShowHide = true;
      } else {
        this.inputShowHide = false;
      }
    },
    submitCompanyLeaveType(){
      axios.post(this.$CompanyLeaveTypes,
        {
          name: this.leaveType,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success("created successfully");
            this.leaveType='';
            this.getCompanyLeaveTypes();
            this.getSpecificEmployeeLeaveTypes();
          }
        });
    },
  }
}
</script>

<style scoped>
.textRed {
  color: red;
}

.alwd-leave {
  margin-top: 10px;
  font-size: 17px;
}

.periodList{
  align-items: end;
}
.periodList input{
  height: 25px;
  width: 80px;
}
.periodList select{
  min-height: 25px;
  width: 100%;
}
.periodList li{
  flex-grow: 1;
}
.periodList li:only-child{
  flex-grow: 0;
}
.periodList li:first-child{
  flex-grow: 0;
  width: 99px;
}
.periodList li div{
  width: 100%;
}
</style>
